import { SETTINGS as general } from "views/Configuration/settings/payments/general";

export const SETTINGS = { general };
